<script>
    import { link } from 'svelte-routing';
    export let packagename;
    export let type;
    export let about;
    export let description;
    export let price;
    export let bookinglink;
</script>
<div class="d-flex gap-20 mobile-fc" style="margin-bottom: 20px;">
    <div class="camping-stay-details">
        <div class="amenities_wrapper">
            <h2>{packagename}</h2>
            <p style="text-align: justify;">Hut Type : {type}</p>
            <p style="text-align: justify;">About : {about}</p>
            <p style="text-align: justify;">{description}</p>
            <div class="room-price_cottage">{price}</div>
            <div class="d-flex align-items-center justify-content-center">
                <a href={bookinglink} use:link class="calluna-button btn btn-primary  style-1 accomodation_gallery_btn" target="_self" title="Book Your Getaway" rel="">
                    <span class="calluna-button-inner">Book Camping</span>
                </a>
            </div>
        </div>
    </div>
    <div class="amenities_items_wrapper home_block_box_bg acc_amenities">
        <div class="row">
        <div class="col-sm-6">
            <label for="">
            Check In/Out
            </label>
            <p class="item-text">
                3pm - 12pm
            </p>
        </div>
        <div class="col-sm-6">
            <label for="">
            Occupancy
            </label>
            <p class="item-text">
                2 Adults / Tent
            </p>
        </div>
        </div>
        <div class="row">
        <div class="col-sm-6">
            <label for="">
            Complimentary Welcome mocktail
            </label>
            <p class="item-text">
                Yes
            </p>
        </div>
        <div class="col-sm-6">
            <label for="">
            Wifi Connectivity
            </label>
            <p class="item-text">
                Yes
            </p>
        </div>
        </div>
        <div class="row">
        <div class="col-sm-6">
            <label for="">
            Adventure Coupons
            </label>
            <p class="item-text">
                10 / Per Adult
            </p>
        </div>
        <div class="col-sm-6">
            <label for="">
            Television
            </label>
            <p class="item-text">
                No
            </p>
        </div>
        </div>
        <div class="row">
        <div class="col-sm-6">
            <label for="">
            Airconditioning
            </label>
            <p class="item-text">
                No
            </p>
        </div>
        <div class="col-sm-6">
            <label for="">
            Room Service
            </label>
            <p class="item-text">
                N/A
            </p>
        </div>
        </div>
        <div class="row">
        <div class="col-sm-6">
            <label for="">
            Shower rooms / Toilets
            </label>
            <p class="item-text">
                Common shared
            </p>
        </div>
        <div class="col-sm-6">
            <label for="">
            Meal Included</label>
            <p class="item-text">
                BBQ Starter , Buffet Dinner &amp; Buffet Breakfast
            </p>
        </div>
        </div>
        <div class="row">
        <div class="col-sm-6">
            <label for="">&nbsp;</label>
            <p class="item-text">&nbsp;</p>
        </div>
        </div>
    </div>
</div>
<style>
    .camping-stay-details {
        background-color: #967a50;
        padding: 6% 0;
        width: 50%;
    }

    p {
        color: #fff;
        font-size: 1.2rem;
        line-height: 1.5rem;
    }

    .amenities_items_wrapper p {
        color: #444444;
    }

    .amenities_wrapper {
        padding-left: 16%;
        padding-right: 12%;
    }

    .room-price_cottage {
        font-family: arial;
        font-size: 20px;
        font-weight: 500;
        padding-bottom: 20px;
        text-align: center;
        color: #fff;
    }

    .accomodation_gallery_btn {
        background: #222953;
        border-radius: 10px !important;
        color: #fff !important;
    }
    
    .amenities_items_wrapper {
        margin-left: 20px;
        margin-right: 25px;
        padding: 5% 5% 5% 10%;
        width: 50%;
    }

    @media only screen and (min-width: 320px) and (max-width: 600px) {

        .camping-stay-details {
            width: 100%;
        }

        :global(.mobile-fc) {
            flex-flow: column;
        }

        .amenities_items_wrapper {
            width: 88%;
        }
    }
</style>